import jMoment from "jalali-moment";

type Props = {
  date: string | undefined;
  format?: string;
  iso?: boolean; // Add an option for ISO output
};

function convertGregorianToJalali({ date, format = "jYYYY/jMM/jDD", iso = false }: Props): string {
  const momentDate = jMoment(date);

  if (iso) {
    return momentDate.toISOString(); // Convert to ISO format
  }

  return momentDate.format(format); // Default formatting
}

export default convertGregorianToJalali;
